<template>
    <div>
        <tab name="6">{{userName}}(ID:{{id}})</tab>
        <user-auth :userId="id" :userType="3" :userName.sync="userName"></user-auth>
    </div>
</template>

<script>
import Tab from './components/tab';
import UserAuth from '@/views/user/components/user-auth';
export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    components:{
        Tab,UserAuth
    },
    data() {
        return {
            userName:''
        };
    }
}
</script>